module.exports = __webpack_public_path__ + "Lato-Black.868e2959f597920bea2b.woff";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-Black.woff
// module id = ../../../../../src/assets/fonts/Lato-Black.woff
// module chunks = styles